/* eslint-disable no-unused-vars */
import { HiChevronDoubleRight, HiChevronDoubleLeft } from 'react-icons/hi';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { classNames } from '../../utils';
import { handleMenuOpen } from '../../redux/layout';
import navigation from '../../navigation';
// import swLogo from '../../assets/icons/SW LOgo 1.svg';
import swLogo from '../../assets/icons/fiveYearlogo.svg';
import { navLinks } from '../../utils/constants';

export default function Sidebar() {
  const { menuHovering, menuOpen, sidebarOpen } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
  const location = useLocation();

  const showFullWidth = menuHovering || menuOpen;
  const currentActiveLink = location.pathname;

  return (
    <>
      {(menuHovering || menuOpen) && !sidebarOpen ? (
        <div className="w-5 text-gray-600 absolute right-0 mt-1 mr-2">
          {menuOpen
            ? <HiChevronDoubleLeft className="cursor-pointer" onClick={() => dispatch(handleMenuOpen(false))} />
            : <HiChevronDoubleRight className="cursor-pointer" onClick={() => dispatch(handleMenuOpen(true))} />}
        </div>
      ) : null}
      <div className="flex items-center flex-shrink-0 px-4 ">
        <img
          className="h-16 w-auto"
          src={swLogo}
          alt="Synergyworks"
        />
      </div>
      <div className="mt-5 flex-grow flex flex-col relative">
        <nav className="flex-1 px-2 pb-4 space-y-6 flex flex-col mt-4 z-20">
          {
            navLinks.map((el, i) => (
              <motion.a
                whileInView={{
                  x: [-200, 0],
                  opacity: [0.6, 1],
                }}
                transition={{
                  delay: 0.2 * i,
                }}
                key={el.title}
                className="text-lg font-semibold"
                href={el.to}
                target="_blank"
                rel="noreferrer"
              >
                {el.title}
              </motion.a>
            ))
          }
        </nav>

        {/* ---blobs---- */}
        <div className="sidebar-blob-1" />
        <div className="sidebar-blob-2" />
      </div>
    </>
  );
}
